'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _assign = require('../../common/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Arrow(props) {
  var style = (0, _assign2.default)({}, props.style);
  var wrapperStyle = (0, _assign2.default)({}, props.position);

  var arrowSize = {
    height: props.size,
    width: props.size
  };
  (0, _assign2.default)(style, arrowSize);

  // 1/2 * H * 2^1/2
  var wrapperSize = 2 * (0.5 * props.size * Math.pow(2, 0.5));
  if (wrapperSize) {
    wrapperStyle.width = wrapperSize;
    wrapperStyle.height = wrapperSize;
  }

  return _react2.default.createElement(
    'div',
    { className: props.wrapperClassName, style: wrapperStyle },
    _react2.default.createElement('div', { className: props.className, style: style })
  );
} /**
   * Copyright (c) 2015-present, Zippy Technologies
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

Arrow.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  size: _propTypes2.default.number,
  position: _propTypes2.default.shape({
    top: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    left: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  })
};

exports.default = Arrow;